import * as React from "react";
import {
  Show,
  TextField,
  ShowProps,
  useRecordContext,
  DateField,
  SelectField,
  RichTextField,
  ArrayField,
  SingleFieldList,
  ChipField,
  TabbedShowLayout,
  Link,
  TopToolbar,
  EditButton,
  BooleanField,
  UrlField,
  useGetList,
} from "react-admin";
import { Divider } from "@mui/material";
import HowToVoteIcon from "@mui/icons-material/HowToVote";

import { DEPARTMENTS } from "../../../constants";

const CustomActions = () => {
  const record = useRecordContext();
  return (
    <TopToolbar>
      {record && (
        <Link
          to={`/job-applications?filter={"reference"%3A"${record.reference}"}`}
        >
          <HowToVoteIcon />
          Ver postulaciones
        </Link>
      )}
      <EditButton />
    </TopToolbar>
  );
};

const JobOfferTitle = () => {
  const record = useRecordContext();
  if (!record) return null;
  return <>{record.title}</>;
};

export const ViewJobOffer: React.FC<ShowProps> = (props) => {
  const { data: statuses = [], isLoading: isLoadingStatuses } = useGetList("statuses");

  return (
    <Show {...props} title={<JobOfferTitle />} actions={<CustomActions />}>
      <TabbedShowLayout spacing={2} divider={<Divider flexItem />}>
        <TabbedShowLayout.Tab label="Oferta" spacing={100}>
          <TextField source="title" fullWidth />
          <BooleanField source="isFeatured" label="Oferta destacada" />
          <SelectField
            source="statusId"
            choices={isLoadingStatuses ? [] : statuses}
            label="Estado"
          ></SelectField>
          <TextField source="reference" label="Nº de referencia" />
          <DateField source="startDate" label="Fecha de inicio" />
          <DateField source="endDate" label="Fecha de fin" />
          <TextField source="slug" />
          <TextField source="address1" label="Dirección" />
          <SelectField source="department" choices={DEPARTMENTS} />

          <UrlField
            source="companyLogoUrl"
            label="Logo de la empresa"
          ></UrlField>
          <ArrayField source="categories" fullWidth label="Categorias">
            <SingleFieldList>
              <ChipField source="name" />
            </SingleFieldList>
          </ArrayField>
          <TextField
            source="workingHours"
            label="Horario laboral"
            fullWidth
          ></TextField>
          <TextField source="salary" label="Salario" fullWidth />
          <RichTextField source="description" label="Descripcion" fullWidth />
        </TabbedShowLayout.Tab>
      </TabbedShowLayout>
    </Show>
  );
};
